window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.Background_Blue = function() {
	this.initialize(img.SplashAssets_Background_Blue);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,977,2052);


(lib.Button_disabled = function() {
	this.initialize(img.SplashAssets_Button_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.Button_down = function() {
	this.initialize(img.SplashAssets_Button_down);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.Button_up = function() {
	this.initialize(img.SplashAssets_Button_up);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.CharacterShadow = function() {
	this.initialize(img.SplashAssets_CharacterShadow);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,294,163);


(lib.factory1 = function() {
	this.initialize(img.SplashAssets_factory1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1193,1041);


(lib.factory2 = function() {
	this.initialize(img.SplashAssets_factory2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,435,917);


(lib.factory3 = function() {
	this.initialize(img.SplashAssets_factory3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,139,1170);


(lib.factory4 = function() {
	this.initialize(img.SplashAssets_factory4);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,796,1573);


(lib.gambit = function() {
	this.initialize(img.SplashAssets_gambit);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,492,657);


(lib.gambit_closed = function() {
	this.initialize(img.SplashAssets_gambit_closed);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,492,657);


(lib.Ground_Iso = function() {
	this.initialize(img.SplashAssets_Ground_Iso);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1335,1539);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.TextSamplesSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// tf
	this.textfield1 = new cjs.Text("Font", "120px 'Roboto'", "#FF0000");
	this.textfield1.name = "textfield1";
	this.textfield1.lineHeight = 158;
	this.textfield1.lineWidth = 353;
	this.textfield1.parent = this;
	this.textfield1.setTransform(90.05,71.3);
ranj.TextOffsetFixer.fix(this.textfield1);

	this.timeline.addTween(cjs.Tween.get(this.textfield1).wait(1));

	// tf
	this.textfield2 = new cjs.Text("Font ", "60px 'Roboto'");
	this.textfield2.name = "textfield2";
	this.textfield2.lineHeight = 79;
	this.textfield2.lineWidth = 282;
	this.textfield2.parent = this;
	this.textfield2.setTransform(95,85.6);
ranj.TextOffsetFixer.fix(this.textfield2);

	this.timeline.addTween(cjs.Tween.get(this.textfield2).wait(1));

	// tf
	this.textfield2_1 = new cjs.Text("Font ", "30px 'Roboto'", "#0000FF");
	this.textfield2_1.name = "textfield2_1";
	this.textfield2_1.lineHeight = 40;
	this.textfield2_1.lineWidth = 93;
	this.textfield2_1.parent = this;
	this.textfield2_1.setTransform(97.45,92.8);
ranj.TextOffsetFixer.fix(this.textfield2_1);

	this.timeline.addTween(cjs.Tween.get(this.textfield2_1).wait(1));

	// guide 
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0000FF").ss(1,1,1,3,true).p("AH0AAIn0AAIAAH0AAAAAInzAAAAAnzIAAHz");
	this.shape.setTransform(100,100);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TextSamplesSkin, new cjs.Rectangle(49,49,1091.3,902.2), null);


(lib.Gambit = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.gambit();
	this.instance.setTransform(107.65,-297,0.4871,0.4871,0,0,180);

	this.instance_1 = new lib.gambit_closed();
	this.instance_1.setTransform(107.65,-297,0.4871,0.4871,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},189).to({state:[{t:this.instance}]},10).to({state:[{t:this.instance}]},300).wait(1));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow();
	this.instance_2.setTransform(-147,-82);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(500));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-147,-297,294,378);


(lib.factory4_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.factory4();
	this.instance.setTransform(-398,-786.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.factory4_1, new cjs.Rectangle(-398,-786.5,796,1573), null);


(lib.factory3_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.factory2();
	this.instance.setTransform(-217.5,-458.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.factory3_1, new cjs.Rectangle(-217.5,-458.5,435,917), null);


(lib.factory1_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.factory1();
	this.instance.setTransform(-596.5,-520.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.factory1_1, new cjs.Rectangle(-596.5,-520.5,1193,1041), null);


(lib.chimney = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.factory3();
	this.instance.setTransform(-69.5,-585);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.chimney, new cjs.Rectangle(-69.5,-585,139,1170), null);


(lib.Background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Background_Blue();
	this.instance.setTransform(-666,-1054,1.3643,1.0273);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Background, new cjs.Rectangle(-667.4,-1055,1334.9,2110), null);


(lib.LoadingBarBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.bf(img.SplashAssets_Button_up, null, new cjs.Matrix2D(1.012,0,0,1,-218.9,-85)).s().p("A3+AeIAAg7MAv8AAAIAAA7g");
	this.shape.setTransform(153.45,3.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LoadingBarBar, new cjs.Rectangle(0,0.5,306.9,6), null);


(lib.StartGameButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {up:0,over:1,down:2,disabled:3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text Up
	this.upLabelTextField = new cjs.Text("start", "20px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 24;
	this.upLabelTextField.lineWidth = 146;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(0.05,-13.9);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text Over
	this.overLabelTextField = new cjs.Text("start", "20px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 24;
	this.overLabelTextField.lineWidth = 146;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(0.05,-13.9);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text Down
	this.downLabelTextField = new cjs.Text("start", "20px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 24;
	this.downLabelTextField.lineWidth = 146;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(0.05,-13.9);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text Disabled
	this.disabledLabelTextField = new cjs.Text("start", "20px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 24;
	this.disabledLabelTextField.lineWidth = 146;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(0.05,-13.9);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.Button_up();
	this.instance.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_1 = new lib.Button_down();
	this.instance_1.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_2 = new lib.Button_disabled();
	this.instance_2.setTransform(-86.6,-30.9,0.4,0.3999);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-86.6,-30.9,173.2,68);


(lib.LoadingBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_99 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(99).call(this.frame_99).wait(1));

	// LoadingBarBar
	this.instance = new lib.LoadingBarBar();
	this.instance.setTransform(3.75,10,0.0227,1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({scaleX:0.9401},99).wait(1));

	// bg
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#EDF0F5").s().p("A2zAyIAAhjMAtnAAAIAABjg");
	this.shape.setTransform(147.85,13.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(100));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(1.9,8.5,292,10);


(lib.SplashLoadScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// startbutton
	this.startButton = new lib.StartGameButton();
	this.startButton.name = "startButton";
	this.startButton.setTransform(0,691.35,2.7273,2.7273);

	this.timeline.addTween(cjs.Tween.get(this.startButton).wait(1));

	// loadingTextField
	this.loadingTextField = new cjs.Text("loading", "13px 'Roboto Medium'", "#FFFFFF");
	this.loadingTextField.name = "loadingTextField";
	this.loadingTextField.textAlign = "center";
	this.loadingTextField.lineHeight = 16;
	this.loadingTextField.lineWidth = 289;
	this.loadingTextField.parent = this;
	this.loadingTextField.setTransform(0,746.05,2.7273,2.7273);
ranj.TextOffsetFixer.fix(this.loadingTextField);

	this.timeline.addTween(cjs.Tween.get(this.loadingTextField).wait(1));

	// bodyTextField
	this.bodyTextfield = new cjs.Text("In this game you help a team develop new chocolate products at a big candy manufacturer.\n\nYou and your team will face various challenges. Pick the options that are closest to what you would do in order to deal with them.\n\nGood luck!", "40px 'Roboto'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 65;
	this.bodyTextfield.lineWidth = 875;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-431.8,-578.4527,0.9999,0.9999);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// versionTextField
	this.versionTextField = new cjs.Text("v1.0.12 commitslug", "italic 14px 'Roboto'", "#999999");
	this.versionTextField.name = "versionTextField";
	this.versionTextField.textAlign = "right";
	this.versionTextField.lineHeight = 17;
	this.versionTextField.lineWidth = 199;
	this.versionTextField.parent = this;
	this.versionTextField.setTransform(515.65,803.55,2.7273,2.7273);
ranj.TextOffsetFixer.fix(this.versionTextField);

	this.timeline.addTween(cjs.Tween.get(this.versionTextField).wait(1));

	// titleTextField
	this.titleTextfield = new cjs.Text("Life is Sweet", "108px 'Roboto Medium'", "#FFFFFF");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 130;
	this.titleTextfield.lineWidth = 867;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-431.8,-793.45);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).wait(1));

	// loadingBar
	this.loadingBar = new lib.LoadingBar();
	this.loadingBar.name = "loadingBar";
	this.loadingBar.setTransform(26.55,721.25,2.7273,2.7273,0,0,0,157.6,12.3);

	this.timeline.addTween(cjs.Tween.get(this.loadingBar).wait(1));

	// Layer_2
	this.elem2 = new lib.factory1_1();
	this.elem2.name = "elem2";
	this.elem2.setTransform(202.55,792.25,0.7215,0.7215,0,0,0,0.1,0.1);

	this.elem4 = new lib.factory3_1();
	this.elem4.name = "elem4";
	this.elem4.setTransform(-316.85,684.7,0.7215,0.7215);

	this.elem5 = new lib.Gambit();
	this.elem5.name = "elem5";
	this.elem5.setTransform(-120.15,549.7,0.5918,0.5918,0,0,0,0,0.1);

	this.elem8 = new lib.chimney();
	this.elem8.name = "elem8";
	this.elem8.setTransform(-544.2,541.45,0.7215,0.7215,0,0,0,-0.1,0.2);

	this.elem6 = new lib.factory4_1();
	this.elem6.name = "elem6";
	this.elem6.setTransform(96.2,356,0.7215,0.7215,0,0,0,0.2,0.1);

	this.elem10 = new lib.chimney();
	this.elem10.name = "elem10";
	this.elem10.setTransform(427.25,180,0.606,0.606,0,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem10},{t:this.elem6},{t:this.elem8},{t:this.elem5},{t:this.elem4},{t:this.elem2}]}).wait(1));

	// Layer_3
	this.instance = new lib.Ground_Iso();
	this.instance.setTransform(-667,-151,1.0037,1.0037);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SplashLoadScreenSkin, new cjs.Rectangle(-667.5,-1184.2,1746.9,2855.2), null);


// stage content:
(lib.SplashAssets = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// TextSamplesSkin
	this.instance = new lib.TextSamplesSkin();
	this.instance.setTransform(-200.2,-554.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 1
	this.instance_1 = new lib.SplashLoadScreenSkin();
	this.instance_1.setTransform(538.8,872,1,1,0,0,0,-1.2,1);

	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FF0000").ss(1,1,1,3,true).p("AAArbIAAW3");
	this.shape.setTransform(116.8,186.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.instance_1}]}).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(371,273.2,841.9000000000001,1991.6000000000001);
// library properties:
lib.properties = {
	id: '2D758ABF18A3194E856740076AC96F36',
	width: 1080,
	height: 1742,
	fps: 24,
	color: "#333333",
	opacity: 1.00,
	manifest: [
		{src:"assets/skins/images/SplashAssets/Background_Blue.png", id:"SplashAssets_Background_Blue", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/Button_disabled.png", id:"SplashAssets_Button_disabled", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/Button_down.png", id:"SplashAssets_Button_down", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/Button_up.png", id:"SplashAssets_Button_up", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/CharacterShadow.png", id:"SplashAssets_CharacterShadow", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/factory1.png", id:"SplashAssets_factory1", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/factory2.png", id:"SplashAssets_factory2", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/factory3.png", id:"SplashAssets_factory3", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/factory4.png", id:"SplashAssets_factory4", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/gambit.png", id:"SplashAssets_gambit", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/gambit_closed.png", id:"SplashAssets_gambit_closed", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/Ground_Iso.png", id:"SplashAssets_Ground_Iso", bundle:"SplashAssets"}
	],
	preloads: []
};



})(lib.SplashAssets = {}, images, ss, createjs);
module.exports = lib.SplashAssets;